import Dashboard from '@/api/dashboard'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  fetchTotal(context = {}) {
    return Dashboard.getTotal().then(response => {
      return Promise.resolve(response)
    })
  },
  fetchStudentStatus(context, attrubutes = {}) {
    return Dashboard.getStudentStatus({
      params: {
        group_by: attrubutes.group_by
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchSaleItem(context, attrubutes = {}) {
    return Dashboard.getSaleItem({
      params: {
        group_by: attrubutes.group_by,
        inv_date_by: attrubutes.inv_date_by,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchUnpaidStudent(context, attrubutes = {}) {
    return Dashboard.fetchUnpaidStudent({
      params: {
        group_by: attrubutes.group_by
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchIncomeByFee(context, attrubutes = {}) {
    return Dashboard.fetchIncomeByFee({
      params: {
        group_by: attrubutes.group_by
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchTotalStudent(context, attrubutes = {}) {
    return Dashboard.getTotalStudent({
      params: {
        group_by: attrubutes.group_by
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchStudentAttendance(context, attrubutes = {}) {
    return Dashboard.getStudentAttendance({
      params: {
        group_by: attrubutes.group_by,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchStudentGrade(context, attrubutes = {}) {
    return Dashboard.getStudentGrade({
      params: {
        group_by: attrubutes.group_by
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchCampusAndStudentPickup(context, attrubutes = {}) {
    return Dashboard.fetchCampusAndStudentPickup({
      params: {
        branch_id: attrubutes.branch_id,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response)
    })
  }
}
